
import { useState } from "react"
import { Paper, Button, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { useSelector, useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { obtenerAereosPaginaAction, obtenerAereosRegistrosAction } from "./../../../ducks/aereosDuck"
import BackDrop from "../../../global/BackDrop"

const columns = [
    { id: "numero", minWidth: 50, align: "center", label: "#" },
    { id: "paquete", minWidth: 50, align: "center", label: "Paquete" },
    { id: "cv", minWidth: 50, align: "center", label: "Clave Viaje" },
    { id: "fechaViaje", minWidth: 50, align: "center", label: "Fecha Viaje" },
    { id: "diaaereo", minWidth: 50, align: "center", label: "Días Reserva Aereo" },
    { id: "noViajes", minWidth: 50, align: "center", label: "No. Viajes" },
    { id: "accion", minWidth: 50, align: "center", label: "Grupos" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TAereo = () => {
    const { aereos, total, pagina, registroPagina } = useSelector(store => store.aereos)
    const rows = aereos
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [load, setLoad] = useState(false)
    const handleChangePage = (event, newPage) => {
        setLoad(true)
        dispatch(obtenerAereosPaginaAction({ Pagina: newPage })).then(Response => {
            setLoad(false)
        })
    }
    const handleChangeRowsPerPage = (event) => {
        setLoad(true)
        dispatch(obtenerAereosRegistrosAction({ Registros: +event.target.value })).then(Response => {
            setLoad(false)
        })
    }
    const handleDetalle = (grupo) => {
        history.push(`/Aereos/${grupo.ClaveViaje}`, {
            reservas: true
        })
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.ClaveViaje}>
                                        <TableCell align='center'>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.Paquete}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.ClaveViaje}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row?.FechaViaje })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.FechaAereo}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.PlazaAereo} / ${row?.PlazaTotal}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button

                                                variant="outlined"
                                                color="primary"
                                                onClick={() => { handleDetalle(row) }}
                                            >
                                                Ver
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registroPagina}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <BackDrop open={load} />
        </div>
    )
}
export default TAereo